export const SCHEDULED_MESSAGE_ERROR = "scheduled-message-error";
export const SCHEDULED_MESSAGE_SENT = "scheduled-message-sent";
export const SCHEDULED_MESSAGE_DELETED = "scheduled-message-deleted";
export const SCHEDULED_MESSAGE_UPDATED = "scheduled-message-updated";
export const SCHEDULED_MESSAGE_CREATED = "scheduled-message-created";
export const NEW_MESSAGE = "new-message";
export const MESSAGE_SEND_ERROR = "message-send-error";
export const MESSAGE_UPDATED = "updated-message";
export const NEW_SERVER = "new-server";
export const PARTICIPANT_REMOVED = "participant-removed";
export const PARTICIPANT_ADDED = "participant-added";
export const PARTICIPANT_LEFT = "participant-left";
export const GROUP_ICON_CHANGED = "group-icon-changed";
export const GROUP_ICON_REMOVED = "group-icon-removed";
export const CHAT_READ_STATUS_CHANGED = "chat-read-status-changed";
export const HELLO_WORLD = "hello-world";
export const TYPING_INDICATOR = "typing-indicator";
export const SERVER_UPDATE = "server-update";
export const SERVER_UPDATE_DOWNLOADING = "server-update-downloading";
export const SERVER_UPDATE_INSTALLING = "server-update-installing";
export const GROUP_NAME_CHANGE = "group-name-change";
export const INCOMING_FACETIME = "incoming-facetime";
export const SETTINGS_BACKUP_CREATED = "settings-backup-created";
export const SETTINGS_BACKUP_DELETED = "settings-backup-deleted";
export const SETTINGS_BACKUP_UPDATED = "settings-backup-updated";
export const THEME_BACKUP_CREATED = "theme-backup-created";
export const THEME_BACKUP_DELETED = "theme-backup-deleted";
export const THEME_BACKUP_UPDATED = "theme-backup-updated";
export const IMESSAGE_ALIASES_REMOVED = "imessage-aliases-removed";
export const FT_CALL_STATUS_CHANGED = "ft-call-status-changed";
export const NEW_FINDMY_LOCATION = "new-findmy-location";
